export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-bookmark-d21cae32d54e6aa69bc7d0840b336d20.svg";